import {FirebaseTopicModel} from "../firebase-topic-model";
import {FreePlayRawMessageData} from "./raw-received-data";
import {FreePlayVoucherData, FreePlayUpdateEventData, UpdatedFreePlayVoucherData} from "./published-data";
import {FirebaseMessageType} from "../firebase-common-consts";
import {FP_VOUCHER_TYPES} from "../../../../../common/const/free_play_consts";
import {Check} from "@sparkware/app-utils";

export class FreePlayTopicModel extends FirebaseTopicModel<FreePlayRawMessageData[], FreePlayUpdateEventData> {
    getTopicName(): string {
        return "freePlay";
    }

    getTopicLabel(): string {
        return "FreePlay";
    }

    protected _mapRawMessageToPublishMessage(rawMessage: FreePlayRawMessageData[]): FreePlayUpdateEventData {
        const added: FreePlayVoucherData[] = [];
        const updated: UpdatedFreePlayVoucherData[] = [];
        const removed: string[] = [];

        rawMessage.forEach((message) => {
            switch (message.type) {
                case FirebaseMessageType.ADDED:
                    if(message.data.PendingDeletion) {
                        removed.push(message.data.FreePlayId.toString())
                    } else {
                        added.push({
                            ID: message.data.FreePlayId.toString(),
                            CurrentBalance: message.data.CurrentBalance,
                            Winnings: message.data.Winnings,
                            FreePlayTypeId: (message.data.FreePlayTypeId?.toString() || FP_VOUCHER_TYPES.FreePlay) as FP_VOUCHER_TYPES,
                            OriginAmount: message.data.OriginAmount,
                            CreationDate: null,
                            ExpirationDate: message.data.ExpirationDate ? new Date(1000 * message.data.ExpirationDate.seconds) : undefined,
                            SpinBetAmount: message.data.MaxBetAmount,
                            GameTypeIDList: message.data.GameTypeIdList,
                            CompanyID: message.data.CompanyId,
                        });
                    }
                    break;
                case FirebaseMessageType.MODIFIED:
                    if(message.data.PendingDeletion) {
                        removed.push(message.data.FreePlayId.toString());
                    } else {
                        const modifiedVoucher: UpdatedFreePlayVoucherData = {
                            ID: message.data.FreePlayId.toString(),
                        };

                        if (!Check.isNullOrUndefined(message.data.CurrentBalance)) {
                            modifiedVoucher.CurrentBalance = message.data.CurrentBalance;
                        }

                        if (!Check.isNullOrUndefined(message.data.Winnings)) {
                            modifiedVoucher.Winnings = message.data.Winnings;
                        }

                        if (!Check.isNullOrUndefined(message.data.FreePlayTypeId)) {
                            modifiedVoucher.FreePlayTypeId = message.data.FreePlayTypeId.toString() as FP_VOUCHER_TYPES;
                        }

                        if (!Check.isNullOrUndefined(message.data.OriginAmount)) {
                            modifiedVoucher.OriginAmount = message.data.OriginAmount;
                        }

                        if (message.data.ExpirationDate) {
                            modifiedVoucher.ExpirationDate = new Date(1000 * message.data.ExpirationDate.seconds);
                        }

                        if (!Check.isNullOrUndefined(message.data.MaxBetAmount)) {
                            modifiedVoucher.SpinBetAmount = message.data.MaxBetAmount;
                        }

                        if(message.data.GameTypeIdList) {
                            modifiedVoucher.GameTypeIDList = message.data.GameTypeIdList;
                        }

                        if (message.data.CompanyId) {
                            modifiedVoucher.CompanyID = message.data.CompanyId;
                        }

                        updated.push(modifiedVoucher);
                    }

                    break;
                case FirebaseMessageType.REMOVED:
                    removed.push(message.data.FreePlayId.toString());
                    break;
            }
        });

        this.analytics.sendMessageUpdate(this.getTopicLabel(), JSON.stringify(rawMessage));

        return {
            added: added,
            updated: updated,
            removed: removed,
        };
    }

}